<template>
  <div class="container">
    <CRow alignHorizontal="end" alignVertical="center">
      <template>
        <div class="containerIconClose" @click="close()">
          <font-awesome-icon icon="times" class="IconClose" />
        </div>
      </template>
    </CRow>

    <CCard class="customCard">
      <CCardHeader class="customCardHeaderActive">
        <CRow
          alignHorizontal="between"
          alignVertical="center"
          class="mr-2 ml-2"
        >
          <h3
            :class="checkLangClass() + ' ' + 'm-2 text_header'"
            v-c-tooltip="{
              content: checkLanguage(cardContent.title),
              placement: 'bottom',
            }"
          >
            {{ checkLanguage(cardContent.title) }}
          </h3>
        </CRow>
      </CCardHeader>
      <CCardBody>
        <CRow class="m-1" align-horizontal="center" align-vertical="center">
          <template>
            <!-- <div :key="item.id"> -->
            <CCol
              xl="6"
              lg="6"
              md="6"
              sm="12"
              style="display: flex; justify-content: center"
            >
              <CRow
                class="img-container"
                alignHorizontal="center"
                alignVertical="center"
                >{{ cardContent.content.item[1].data }}</CRow
              >
            </CCol>
            <!-- </div> -->
            <CCol xl="6" lg="6" md="6" sm="12">
              <CRow
                alignHorizontal="center"
                alignVertical="center"
                style="min-height: 150px"
              >
                <div
                  class="containerIconAudio"
                  @click="playSound(cardContent.content.item[0].data)"
                >
                  <font-awesome-icon icon="volume-up" class="IconClose" />
                </div>
              </CRow>
            </CCol>
          </template>
        </CRow>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import '../../../../assets/scss/_chineseIcon.scss';

export default {
  components: {},
  name: 'CardAudio',
  props: {
    cardContent: Object,
    CardID: String,
  },

  data() {
    return {
      lang: this.$store.getters['language/getLanguage'],
      baseUrl: process.env.VUE_APP_URL_SOUND,
    };
  },

  computed: {
    ...mapGetters({
      storeLanguage: 'language/getLanguage',
    }),
  },

  watch: {
    cardContent: function () {},
    storeLanguage: function (val) {
      this.lang = val;
    },
  },

  mounted() {},

  created() {},

  beforeDestroy() {},
  methods: {
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    playSound(sound) {
      if (sound) {
        var audio = new Audio(this.baseUrl + '' + sound);
        audio.play();
      }
    },
    checkLanguage(val) {
      if (val) {
        for (let i = 0; i <= val.length; i++) {
          if (val[i].key == this.lang) {
            return val[i].value;
          }
        }
      } else {
      }
    },
    close() {
      const closeAction = this.cardContent.navigate.close.action;
      const str = closeAction.split('-');
      this.$store.commit('necessary/setCodePage', str[1]);

      const closePath = `/v3/${str[0]}/${str[1]}`;

      this.$router.push(closePath);
    },
  },
};
</script>

<style scoped>
.img-container {
  font-family: 'Bider';
  background-color: #ebebeb;
  width: 100%;
  height: 350px;
  font-size: 80px;
  border-radius: 10px;
}

@media screen and (max-width: 415px) {
  .text_header {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .img-container {
    height: auto;
    font-size: 60px;
  }
  .containerIconAudio {
    width: 70px;
    height: 70px;
  }
}
</style>
